/*

  From: https://www.npmjs.com/package/draft-js-import-element
  Version used: 1.2.1
  Last modified: 11.30.2017
  Things modified:
    - Removed "use strict" (only needed in npm package)
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateFromMarkdown = require('./stateFromMarkdown');

Object.defineProperty(exports, 'stateFromMarkdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateFromMarkdown).default;
  }
});

var _MarkdownParser = require('./MarkdownParser');

Object.defineProperty(exports, 'MarkdownParser', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MarkdownParser).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


// WEBPACK FOOTER //
// ./src/shared/libraries/draft-js-import-markdown/lib/main.js